<script setup>
import EmojiOrIcon from 'shared/components/EmojiOrIcon.vue';

defineProps({
  title: {
    type: String,
    required: true,
  },
  compact: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: '',
  },
  emoji: {
    type: String,
    default: '',
  },
  isOpen: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['toggle']);

const onToggle = () => {
  emit('toggle');
};
</script>

<template>
  <div class="text-sm">
    <button
      class="flex items-center select-none w-full rounded-lg bg-n-slate-2 outline outline-1 outline-n-weak m-0 cursor-grab justify-between py-2 px-4 drag-handle"
      :class="{ 'rounded-bl-none rounded-br-none': isOpen }"
      @click.stop="onToggle"
    >
      <div class="flex justify-between">
        <EmojiOrIcon class="inline-block w-5" :icon="icon" :emoji="emoji" />
        <h5 class="text-n-slate-12 text-sm mb-0 py-0 pr-2 pl-0">
          {{ title }}
        </h5>
      </div>
      <div class="flex flex-row">
        <slot name="button" />
        <div class="flex justify-end w-3 text-n-blue-11 cursor-pointer">
          <fluent-icon v-if="isOpen" size="24" icon="subtract" type="solid" />
          <fluent-icon v-else size="24" icon="add" type="solid" />
        </div>
      </div>
    </button>
    <!-- Gradiente do topo para o fim de cada caixa (pedido do clube, 12/10): sem ele as seções
         do painel de contato viram uma faixa contínua e é preciso ler os títulos para saber onde
         uma acaba e a outra começa. O degradê parte do tom do cabeçalho e se dissolve, o que dá
         ao bloco um começo e um fim visíveis sem acrescentar mais uma linha de borda. Os tons vêm
         dos tokens, então acompanham o tema claro e o escuro.

         14/10: a primeira versão partia de `slate-2`, o MESMO tom do cabeçalho, e por isso não se
         via. Medido nos tokens: no escuro são 24 25 27 contra um fundo de 17 17 19, sete pontos
         de diferença que somem na tela; no claro a distância é de três pontos. Entregue e
         invisível é o mesmo que não entregue.

         Agora parte de `slate-3` (33 34 37 no escuro, 240 240 243 no claro) e termina a 60% da
         altura: a diferença passa a ser de dezesseis e doze pontos, visível sem virar faixa
         colorida. Parar antes do fim é o que marca o fim do bloco; dissolvido até embaixo, o
         limite voltava a sumir justamente onde ele importa. -->
    <div
      v-if="isOpen"
      class="outline outline-1 outline-n-weak -mt-[-1px] border-t-0 rounded-br-lg rounded-bl-lg bg-gradient-to-b from-n-slate-3 to-transparent to-60%"
      :class="compact ? 'p-0' : 'px-2 py-4'"
    >
      <slot />
    </div>
  </div>
</template>
